<template>
  <div>
    <HeroSection
      :nav-breadcrumbs="[
        {
          href: '/resources',
          title: 'Resources'
        },
        {
          href: canonicalPaths.relative,
          title: 'Article'
        }
      ]"
      :value="heroSection"
    />

    <ArticleSection
      :article="article"
      :value="{}"
      class="mb-16 px-md-16 hero-section hero-below-offset"
    />

    <DividerSection class="mb-16" />

    <ContactCtaSection :value="articlePage.contact_cta_section" class="mb-16" />
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { usePageContext } from '#root/renderer/usePageContext'

const props = defineProps({
  article: {
    required: true,
    type: Object
  },
  articlePage: {
    required: true,
    type: Object
  }
})

const { canonicalPaths } = usePageContext()
const heroSection = computed(() => {
  const section = Object.assign({}, props.articlePage.hero_section)
  section.title = props.article.title
  return section
})
</script>
